export default "__VITE_ASSET__Ddze7RxX__"